import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { RegisterService } from 'src/app/services/register/register.service';
import { AlertListService } from '@xref/ngx';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'xlog-reg-details',
    templateUrl: './details.component.pug',
    styleUrls: ['./details.component.scss'],
    standalone: false
})
export class RegDetailsComponent implements OnInit {
    @Input() detailsForm: UntypedFormGroup;
    @Input() submitting = false;

    @Output() detailsFormSubmitted = new EventEmitter();
    @Output() goBackClicked = new EventEmitter();
    @Output() showTermsConditions = new EventEmitter();

    @ViewChild('detailsFormRef') detailsFormRef: ElementRef;

    loaded = false;

    staffOptionList: any[] = [];
    regionCurrencyList: any[] = [];

    showPassword = false;

    constructor(
        private reg: RegisterService,
        private alertList: AlertListService
    ) {}

    get organisation() { return this.detailsForm.get('organisation'); }
    get numberOfStaff() { return this.detailsForm.get('numberOfStaff'); }
    get password() { return this.detailsForm.get('password'); }
    get termsConditions() { return this.detailsForm.get('termsConditions'); }

    ngOnInit() {
        this.getStaffOptions();
        this.getRegionCurrency();
    }

    setLoaded() {
        this.loaded = (
            this.staffOptionList.length > 0 &&
      this.regionCurrencyList.length > 0
        );
    }

    getStaffOptionsSuccess = (data) => {
        this.staffOptionList = data;
        this.setLoaded();
    };

    getStaffOptionsError = (err) => {
        this.alertList.append([{active: true, type: 'danger', messageKey: 'alerts.generic.error'}]);
    };

    getStaffOptions() {
        this.reg.getNumStaffOptions().subscribe(
            this.getStaffOptionsSuccess,
            this.getStaffOptionsError
        );
    }

    getRegionCurrencySuccess = (data) => {
        this.regionCurrencyList = data;
        this.setLoaded();
    };

    getRegionCurrencyError = (err) => {
        this.alertList.append([{active: true, type: 'danger', messageKey: 'alerts.generic.error'}]);
    };

    getRegionCurrency() {
        this.reg.getRegionCurrency().subscribe(
            this.getRegionCurrencySuccess,
            this.getRegionCurrencyError
        );
    }

    submit(event: any) {
        event.preventDefault();
        event.stopPropagation();

        this.detailsFormSubmitted.emit();
    }

    goBack() {
        this.goBackClicked.emit();
    }

    togglePassword() {
        this.showPassword = !this.showPassword;
    }

    termsConditionsClicked() {
        if (!this.detailsForm.controls.termsConditions.value)
            this.showTermsConditions.emit();
        else
            this.termsConditions.setValue(false);
    }

    showPassUppercaseErr() {
        return (!!this.password.errors && !!this.password.errors.hasOneUppercase);
    }

    showPassMinLenErr() {
        return (
            !!this.password.errors &&
      (!!this.password.errors.minlength || !!this.password.errors.required)
        );
    }

    showPassSpecialCharErr() {
        return !!this.password.errors && !!this.password.errors.hasSpecialChar;
    }

    showPassLowercaseErr() {
        return !!this.password.errors && !!this.password.errors.hasLowercase;
    }

    showPassNumberErr() {
        return !!this.password.errors && !!this.password.errors.hasNumber;
    }


}
